import { render, staticRenderFns } from "./AddGatewayStep2.vue?vue&type=template&id=5b8e1fa4"
import script from "./AddGatewayStep2.vue?vue&type=script&lang=js"
export * from "./AddGatewayStep2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports